import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { RmService } from '../../../services/rm/rm.service';

@Injectable({
  providedIn: 'root'
})
export class RmGuard implements CanActivate {
  constructor(private rmService: RmService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (this.rmService.isLoggedIn()) {
      return true;
    }
    this.router.navigate(['/rm/login'], { queryParams: { returnUrl: state.url } });
    return false;
  }
}
